import React from "react";

//styles
import "./styles.scss";

const ConfirmationModal = ({ onCancel, onConfirm, message }) => {
  return (
    <div className="confirmation-modal">
      <div className="confirmation-modal-content">
        <div className="info">
          <p>{message}</p>
        </div>
        <div className="button-container">
          <button className="cancel-button" onClick={onCancel}>
            Cancel
          </button>
          <button className="confirm-button" onClick={onConfirm}>
            Okay
          </button>
        </div>
      </div>
    </div>
  );
};

export default ConfirmationModal;
